import { render, staticRenderFns } from "./specifications-table.vue?vue&type=template&id=124534f4&"
import script from "./specifications-table.vue?vue&type=script&lang=js&"
export * from "./specifications-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124534f4')) {
      api.createRecord('124534f4', component.options)
    } else {
      api.reload('124534f4', component.options)
    }
    module.hot.accept("./specifications-table.vue?vue&type=template&id=124534f4&", function () {
      api.rerender('124534f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/externalPurchases/partials/specifications-table.vue"
export default component.exports